import { Popper, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { ChangeEvent, FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumento from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumento';
import IClientes from 'Infotrack@Modelos/smartStock/clientes/entidades/clientes';

interface ICampoClienteIdProps {
    clientes: IClientes[];
    deshabilitado: boolean;
    manejarCambioCampo: (nombreCampo: keyof IDocumento, nuevoValor: IDocumento[keyof IDocumento]) => any;
    valor?: string;
}

const CampoClienteId: FunctionComponent<ICampoClienteIdProps> = ({
    deshabilitado,
    manejarCambioCampo,
    clientes,
    valor,
}) => (
    <Autocomplete
        disabled={deshabilitado}
        getOptionLabel={(c) => c.DescripcionCliente}
        onChange={(_: ChangeEvent<{}>, value: IClientes | null) =>
            manejarCambioCampo('ClienteId', value ? value.ClienteId! : '')
        }
        options={clientes}
        PopperComponent={(props) => <Popper {...props} placement="bottom-start" style={{ width: 'auto' }} />}
        renderInput={(params) => (
            <TextField
                {...params}
                fullWidth
                label={<Texto id="FormularioDocumento.CampoClienteId.Nombre" />}
                required
            />
        )}
        value={clientes.find((c) => c.ClienteId === valor) || null}
        id={`CampoCliente-${valor}`}

    />
);

export default CampoClienteId;
